import { render, staticRenderFns } from "./visaPage.vue?vue&type=template&id=4a09c160&scoped=true"
import script from "./visaPage.vue?vue&type=script&lang=js"
export * from "./visaPage.vue?vue&type=script&lang=js"
import style0 from "./visaPage.vue?vue&type=style&index=0&id=4a09c160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a09c160",
  null
  
)

export default component.exports